import Redux from 'redux';
import * as Bixby from '$/core';
import {
  RELEASE_FEATURE_FLAGS_LOADING,
  RELEASE_FEATURE_FLAGS_SUCCESS,
  RELEASE_FEATURE_FLAGS_FAILURE,
  ReleaseFeatureFlagsState,
  ReleaseFeatureFlagsActionTypes,
} from './types';

const initialState: ReleaseFeatureFlagsState = {
  isLoading: false,
  data: undefined,
  error: undefined,
};

const releaseFeatureFlagsReducer: Redux.Reducer<ReleaseFeatureFlagsState> = (
  state = initialState,
  action: ReleaseFeatureFlagsActionTypes
): ReleaseFeatureFlagsState => {
  switch (action.type) {
    case RELEASE_FEATURE_FLAGS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: undefined,
      };
    case RELEASE_FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload as Bixby.Models.ReleaseFeatureFlag[],
        error: undefined,
      };
    case RELEASE_FEATURE_FLAGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Bixby.Models.BixbyError,
        data: undefined,
      };
    default:
      return state;
  }
};

export default releaseFeatureFlagsReducer;
